import { actions$ } from "mini-rx-store";
import { catchError, map, of, switchMap } from "rxjs";
import { ofType } from "ts-action-operators";

import { loadSitzungenListe } from "./sitzungen-actions.js";
import { sitzungenService } from "../service/sitzungen-service.js";

export const loadSitzungenListeEffect = actions$.pipe(
  ofType(loadSitzungenListe.action),
  switchMap(() =>
    sitzungenService.ladeListe().pipe(
      map((liste) => loadSitzungenListe.success(liste)),
      catchError((err) => of(loadSitzungenListe.fail(err))),
    ),
  ),
);

export const sitzungenEffects = [loadSitzungenListeEffect];
